import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from '../../styles/animations/remax/remax-card.module.css';

type RemaxCardProps = {
    title?: string | null;
    className?: string | null;
    cardClassName?: string | null;
    children?: ReactNode | null;
};

function RemaxCard({ title, className, cardClassName, children }: RemaxCardProps) {
    return (
        <div className={classNames(styles.container, className)}>
            <div className={classNames(styles.card, cardClassName)}>
                <h3>{title}</h3>
                {children}
            </div>
        </div>
    );
}

export default RemaxCard;
